export default __webpack_public_path__ + "static/media/026-diamond ring.de8efd67.svg";